
import { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { IoIosSave } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;
`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;

  select{
    &.erro {
      border: 2px solid red;
      
    }
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;


const Input1 = styled.input`

  width: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */

  &.erro {
      border: 2px solid red;
      
    }
`;


const Input2 = styled.input`
  width: auto;
  min-width: 500px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;
const Input3 = styled.input`
  width: 70px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;

const Input4 = styled.input`
  width: auto;
  min-width: 500px;
  height: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;
const H2 = styled.h2`
  color: #575757;
`;

const Button = styled.button`
  padding: 10px 30px;
  background-color: transparent;
  color: #575757;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
  
`;


const Form = ({ urlApi, tipoMaterial, subTipoMaterial, setAtualizaMateriais }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');

  //========================================================SELECT FILTRA O OUTRO
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [subtipoSelecionado, setSubtipoSelecionado] = useState(null);

  // Filtra os subtipos com base no tipo selecionado
  const subtiposFiltrados = subTipoMaterial.filter(
    (sub) => sub.COD_TIPO === tipoSelecionado
  );




  //========================================================ENVIA O CODIGO/RECEBE A DESCRICAO

  const [codigoMaterial, setCodigoMaterial] = useState('');
  const [descricaoMaterial, setDescricaoMaterial] = useState('');


  const getMaterial = async (codigo) => {
    try {
      const response = await axios.get(`${urlApi}controle-reagentes/material`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { codigoMaterial: codigo }
      });

      if (response.data.length > 0) {
        setDescricaoMaterial(response.data[0]);
      } else {
        toast.warn('Material não encontrado');
        setDescricaoMaterial({});
      }

    } catch (err) {
      console.log("Conexão falhou", err);
      toast.error('Erro ao buscar material');
      setDescricaoMaterial({});
    }
  };

  // Chama ao mudar o input e pressionar Enter ou sair do campo (onBlur)
  const handleBuscarMaterial = () => {
    if (codigoMaterial) {
      getMaterial(codigoMaterial);
    }
  };



  //========================================================ADICIONAR O MATERIAL NO LB_MATERIAL
  const [observacao, setObservacao] = useState('');
  const [erros, setErros] = useState({});

  const handleSalvarMaterial = async () => {


    if (observacao && observacao.length > 250) {
      toast.warn('A observação não pode ter mais de 250 caracteres.');
      return;
    }

    const novosErros = {};
    if (!codigoMaterial) novosErros.codigoMaterial = true;
    if (!tipoSelecionado) novosErros.tipoSelecionado = true;
    if (!subtipoSelecionado) novosErros.subtipoSelecionado = true;





    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      toast.warn('Preencha todos os campos obrigatórios corretamente.');
      return;
    }

    setErros({});

    try {
      const payload = {
        cod_material: codigoMaterial.trim(),
        tipo: tipoSelecionado,
        subtipo: subtipoSelecionado,
        observacao: observacao?.trim() || null,
      };

      const res = await axios.post(`${urlApi}controle-reagentes/adicionar-material`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success(res.data.message || 'Material salvo com sucesso!');

      setAtualizaMateriais(true)
    } catch (err) {
      console.error('Erro ao salvar material:', err);
      toast.error(err.response?.data?.error || 'Erro ao salvar material.');
    }
  };



  return (
    <DivGeral>
      <H2>Cadastro de Materiais</H2>

      <Div >
        {/* Select de Tipo */}
        <Label>
          Tipo de Material:
          <select
            className={erros.tipoSelecionado ? 'erro' : ''}
            value={tipoSelecionado || ''}
            onChange={(e) => {
              const valor = parseInt(e.target.value, 10);
              setTipoSelecionado(valor);
              setSubtipoSelecionado(null); // limpa o subtipo ao trocar o tipo
            }}
          >
            <option value="" disabled>Selecione o tipo</option>
            {tipoMaterial.map((tipo) => (
              <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
                {tipo.DESC_TIPO}
              </option>
            ))}
          </select>
        </Label>

        {/* Select de Subtipo (dependente) */}
        <Label >
          Subtipo:
          <select
            className={erros.subtipoSelecionado ? 'erro' : ''}
            value={subtipoSelecionado || ''}
            onChange={(e) => setSubtipoSelecionado(parseInt(e.target.value, 10))}
            disabled={!tipoSelecionado}
          >
            <option value="" disabled>Selecione o subtipo</option>
            {subtiposFiltrados.map((sub) => (
              <option key={sub.COD_SUBTIPO} value={sub.COD_SUBTIPO}>
                {sub.DESC_SUBTIPO}
              </option>
            ))}
          </select>
        </Label>
      </Div>
      <Div>
        <Label>
          Código do Material:
          <Input1
            type="text"
            className={erros.codigoMaterial ? 'erro' : ''}
            value={codigoMaterial}
            onChange={(e) => setCodigoMaterial(e.target.value)}
            onBlur={handleBuscarMaterial}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleBuscarMaterial();
            }}
            disabled={(!tipoSelecionado || !subtipoSelecionado)}
            placeholder="Digite o código"
          />
        </Label>

        {/* Exibe a descrição do material */}
        <Label>
          Descrição:
          <Input2
            type="text"
            value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
            disabled={(!codigoMaterial)}
            readOnly
          />

        </Label>
        <Label>
          Uni:
          <Input3
            type="text"
            value={` ${descricaoMaterial.UNIDADE_MEDIDA || ''}`}
            disabled={(!codigoMaterial)}
            readOnly

          />

        </Label>
      </Div>
      <Div>
        <Label>
          Observação:
          <Input4
            type="text"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            maxLength={250}
            disabled={!codigoMaterial}
            placeholder="Digite uma observação"
          />


        </Label>
      </Div>
      <Div>
        <Button
          disabled={!codigoMaterial || !tipoSelecionado || !subtipoSelecionado}
          onClick={handleSalvarMaterial}
        >
          <IoIosSave color={"green"} />Salvar Material
        </Button>
      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




